// css =>
import "../../BaseStructure.css";
import Styled from "./LogIn.module.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import InputBox from "../../Components/inputBox/inputBox.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";

// react =>
import { useNavigate } from "react-router-dom";
import { useRef, useEffect } from "react";

// utils =>
import { ValidateRequiredFields } from "../../utils/FieldValidation";

// services =>
import { SaveToSession } from "./LogInService";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function LogIn() {

    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const phoneNumberInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        document.title = "ورود به حساب کاربری | ویدوک";

        const saved = sessionStorage.getItem("logInForm");
        if (saved) {
            const data = JSON.parse(saved);
            if (phoneNumberInputRef.current) phoneNumberInputRef.current.value = data.phoneNumber || "";
        }
    }, []);

    return(
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated />

            <div className="row" id={ Styled.LogInHeader }>
                <div className="col-12">
                    <h1>ورود به حساب کاربری</h1>
                </div>
            </div>

            <div className="row" id={ Styled.LogInFrom }>
                <InputBox
                    inputType="tel"
                    maxLenght={ 11 }
                    inputTittle="شماره تلفن"
                    placeHolder="اجباری"
                    defaultValue="09"
                    ref={ phoneNumberInputRef }
                    onChange={ () => {
                        SaveToSession(
                            phoneNumberInputRef
                        );
                    }}
                />
            </div>

            <div className="row" id={ Styled.LogInPageSection }>
                <div className="col-12">
                    <p>کد تایید از طریق پیامک به شماره تماس وارد شده ارسال میشود.</p>
                </div>
                <div className="col-12">
                    <button id={ Styled.LogInAccountButton } onClick={() => {
                        if (ValidateRequiredFields(
                            (message) => showMessage("error", message),
                            phoneNumberInputRef,
                        ) && phoneNumberInputRef.current?.value !== "09") {
                            navigate("/code-receive", {
                                state: {
                                    name: "",
                                    lastName: "",
                                    phoneNumber: phoneNumberInputRef.current?.value,
                                    address: "",
                                    postalCode: "",
                                    emailAddress: "",
                                    actionType: "log-in",
                                }
                            });
                        } else if (phoneNumberInputRef.current?.value === "09") {
                            showMessage("error", "لطفا شماره تلفن خود را وارد کنید!");
                        }
                    }}>
                        <h2>دریافت کد تایید</h2>
                    </button>
                </div>
                <div className="col-12">
                    <br />
                    <span>اگر ثبت نام نکرده اید: </span>
                    <a href="/sign-in"><span style={{ color: 'blue' }}>ایجاد حساب کاربری</span></a>
                </div>
            </div>

            <MenuBar />
        </>
    );
}

export default LogIn;
